module.exports = __webpack_public_path__ + "img/name.a00f4b4f.png";